import { Modal, ModalContentProps, ModalProps } from '@chakra-ui/react';
import React from 'react';

import {
  CmHeading,
  CmModalCloseButton,
  CmModalContent,
  CmModalHeader,
  CmModalOverlay,
} from '@/components/uiParts';

type Props = {
  title: string;
  headerSize?: 'sm' | 'md' | 'lg';
  showCloseButton?: boolean;
  /**
   * モーダル本文の縦スクロール指定です。
   * 既定の 'scroll' は本文の量に関わらずスクロールバーを常時表示するため、
   * 本文が短くスクロール不要なモーダルでは 'auto' を指定してください。
   */
  contentOverflowY?: ModalContentProps['overflowY'];
} & ModalProps;

export const CmModal: React.FC<Props> = ({
  title,
  headerSize = 'lg',
  showCloseButton = true,
  size = '2xl',
  isOpen,
  onClose,
  isCentered,
  // NOTE 誤操作防止でオーバーレイクリックを無効化したい画面があるため受け取る。
  //      既定値は Chakra の closeOnOverlayClick と同じ true です。
  closeOnOverlayClick = true,
  contentOverflowY = 'scroll',
  children,
}) => {
  return (
    <Modal
      scrollBehavior="inside"
      {...{ size, isOpen, onClose, isCentered, closeOnOverlayClick }}
    >
      <CmModalOverlay />
      <CmModalContent
        sx={{
          maxHeight: '80vh',
          overflowY: contentOverflowY,
        }}
      >
        <CmModalHeader>
          <CmHeading size={headerSize} width="90%">
            {title}
          </CmHeading>
        </CmModalHeader>
        {showCloseButton && <CmModalCloseButton size="lg" />}
        {children}
      </CmModalContent>
    </Modal>
  );
};
